module.exports = __webpack_public_path__ + "df1407a0a5e09a39caab0e3260749b84.svg";